type FormSectionTitleProps = Readonly<{
  children: string
}>

const FormSectionTitle = ({ children }: FormSectionTitleProps) => (
  <h2 className="text-base font-heading leading-[22px] tracking-wide font-bold">
    {children}
  </h2>
)

export { FormSectionTitle, type FormSectionTitleProps }
